import React from 'react';
import { ProductImage } from '@noths/polaris-client-ribbons-design-system';
import { Image } from '@noths/polaris-dev-ts-types';

import { IMAGES_ID_PREFIX } from '.';
import { PRODUCT_IMAGES_TAB_ID_PREFIX, PRODUCT_IMAGES_TABPANEL_ID_PREFIX } from '../..';
import { DecorateWithZoomAndPanWrapper } from './DecorateWithZoomAndPanWrapper';
import * as styles from '../../styles/ProductImageModal.styles';

export interface ProductImagesModalProps {
  currentImage: number;
  images: Image[];
  loadedImages: Record<number, boolean>;
  multipleImagesToDisplay: boolean;
  setImageLoaded: (value: React.SetStateAction<Record<number, boolean>>) => void;
}

export const ProductImagesModal = ({
  currentImage,
  images,
  loadedImages,
  multipleImagesToDisplay,
  setImageLoaded,
}: ProductImagesModalProps) => (
  <>
    {images.map(({ href: src, title }, i) => (
      <div
        role="tabpanel"
        aria-labelledby={`${IMAGES_ID_PREFIX}${PRODUCT_IMAGES_TAB_ID_PREFIX}${i}`}
        id={`${IMAGES_ID_PREFIX}${PRODUCT_IMAGES_TABPANEL_ID_PREFIX}${i}`}
        css={styles.tabpanel}
        style={i === currentImage ? {} : { display: 'none' }}
        key={src}
      >
        <DecorateWithZoomAndPanWrapper
          enabled={true}
          loadingSpinner={!loadedImages[i]}
          shouldDisplay={currentImage === i}
        >
          <ProductImage
            src={src}
            size="original"
            alt={`${title}${multipleImagesToDisplay ? `, ${`${i + 1} of ${images.length}`}` : ''}`}
            css={styles.fullScreenImage}
            onLoad={() => setImageLoaded({ ...loadedImages, [i]: true })}
          />
        </DecorateWithZoomAndPanWrapper>
      </div>
    ))}
  </>
);
